import React from "react";
import { motion } from "framer-motion";
import { Box } from "@chakra-ui/react";

/**
 * PageTransition wrapper component for smooth fade in/out animations
 */
const PageTransition = ({ children }) => {
  const pageVariants = {
    initial: {
      opacity: 0,
      y: 10,
    },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.4,
        ease: "easeInOut",
      },
    },
    exit: {
      opacity: 0,
      y: -10,
      transition: {
        duration: 0.3,
        ease: "easeInOut",
      },
    },
  };

  return (
    <motion.div
      key={Math.random()} // Force animation on route change
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <Box>{children}</Box>
    </motion.div>
  );
};

export default PageTransition;
